import PayTo from "./PayTo";
import {
  OplChooseMethod,
  OplConfirmBankPayment,
  OplPaymentFailed,
  OplProcessing,
  OplSuccess,
  OplPaymentDetails,
} from "./sub-pages";
import RouterErrorBoundary from "../RouterErrorBoundary";

export const openPaymentLinkRoutes = {
  path: "/payto/:orgId",
  element: <PayTo />,
  errorElement: <RouterErrorBoundary />,
  children: [
    {
      id: "opl-paymentdetails",
      index: true,
      element: <OplPaymentDetails />,
    },
    {
      id: "opl-choosepaymentmethod",
      path: "choosepaymentmethod",
      element: <OplChooseMethod />,
    },
    {
      id: "opl-confirmpaybybank",
      path: "confirmpaybybank",
      element: <OplConfirmBankPayment />,
    },
    {
      id: "opl-success",
      path: "success",
      element: <OplSuccess />,
    },
    {
      id: "opl-processing",
      path: "processing",
      element: <OplProcessing />,
    },
    {
      id: "opl-paymentfailed",
      path: "paymentfailed",
      element: <OplPaymentFailed />,
    },
  ],
};
